import CONFIG from './config';
import { supabase } from './supabase';
import { fetchWithTimeout, readJsonResponse, responseError } from './apiRequest';

const pending = new Map();

export async function loadCheckoutReceipt(sessionId) {
  if (typeof sessionId !== 'string' || !/^cs_[A-Za-z0-9_]{1,200}$/.test(sessionId)) return null;
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token || !session.user?.id || session.user.is_anonymous) return null;
  const owner = session.user.id;
  const key = `${owner}:${sessionId}`;
  if (!pending.has(key)) {
    const request = (async () => {
      const response = await fetchWithTimeout(`${CONFIG.API_BASE.replace(/\/+$/, '')}/billing/checkout-receipt`, {
        method: 'POST', cache: 'no-store',
        headers: { Authorization: `Bearer ${session.access_token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId }),
      }, 15000);
      const receipt = await readJsonResponse(response);
      if (!response.ok) throw responseError(response, receipt, 'Checkout receipt unavailable');
      if (receipt?.checkout_verified !== true || receipt?.paid !== true) return null;
      if (receipt.transaction_id !== sessionId || typeof receipt.value !== 'number'
          || !Number.isFinite(receipt.value) || receipt.value <= 0 || !/^[A-Z]{3}$/.test(receipt.currency)) return null;
      // A manually reopened old success URL is not a new conversion today.
      if (!Number.isSafeInteger(receipt.created_at) || receipt.created_at * 1000 < Date.now() - 86400000
          || receipt.created_at * 1000 > Date.now() + 300000) return null;
      return receipt;
    })();
    pending.set(key, request);
    request.finally(() => pending.delete(key)).catch(() => {});
  }
  const receipt = await pending.get(key);
  const { data: { session: current } } = await supabase.auth.getSession();
  return current?.user?.id === owner ? receipt : null;
}
